import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

const icons = {
  MonetizationOnIcon
};


const excessfee = {
  id: 'registeredcases',
  type: 'group',
  children: [
    {
      id: 'Excessfees',
      title: 'Excess Fees',
      type: 'item',
      url: '/Excessfees',
      icon: icons.MonetizationOnIcon,
      // breadcrumbs: false
    }
  ]
};

export default excessfee;
